
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.104 0a3.945 3.945 0 00-3.95 3.934c0 1.779 2.57 4.963 3.542 6.15a.55.55 0 00.784 0c.972-1.187 3.573-4.371 3.573-6.15C13.053 1.779 11.266 0 9.103 0zm0 5.245c-.753 0-1.317-.562-1.317-1.311 0-.718.564-1.312 1.317-1.312.72 0 1.316.594 1.316 1.312 0 .749-.595 1.31-1.316 1.31zm-8.4 1.498c-.346.156-.628.562-.628.937v7.805c0 .374.345.624.658.468l4.357-1.967V6.712c-.282-.5-.532-.968-.69-1.436L.704 6.743zm8.4 4.496c-.47 0-.878-.188-1.16-.531-.627-.718-1.285-1.53-1.85-2.404v5.682l6.019 1.998v-7.68a25.703 25.703 0 01-1.88 2.404c-.283.343-.69.53-1.13.53zm8.338-6.182l-4.326 1.936v8.991l4.357-1.717c.345-.156.658-.562.658-.937V5.526c0-.375-.376-.625-.69-.469z","fill":"currentColor"}})])
          )
        }
      }
    